export default __webpack_public_path__ + "static/media/Titanslayer Cloak.9a0e9cb8.jpg";